import { render, staticRenderFns } from "./BurstCarousel.vue?vue&type=template&id=51f4abd1&"
import script from "./BurstCarousel.vue?vue&type=script&lang=ts&"
export * from "./BurstCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports